class Instruction {
  constructor (props = {}, key) {
    this.key = key
    this.content = props.content
    this.priority = props.priority
    this.section = props.section
    this.text = props.text
  }
}

export { Instruction }



// WEBPACK FOOTER //
// ./src/models/Instruction.js